import React from 'react';
import './ImageModal.css';

const ImageModal = ({ show, onClose, images, description, pdfLinks }) => {
  if (!show) return null;

  return (
    <div className="image-modal-overlay">
      <div className="image-modal-content">
        <button onClick={onClose} className="image-modal-close-button">&times;</button>
        {description && <p className="image-modal-description">{description}</p>}
        <div className="image-modal-gallery">
          {images.map((img, index) => (
            <img key={index} src={img} alt={`Image ${index + 1}`} className="image-modal-image" />
          ))}
        </div>
        {pdfLinks && pdfLinks.length > 0 && (
          <div className="image-modal-pdf-links">
            <h3>Related Documents</h3>
            <ul>
              {pdfLinks.map((pdf, index) => (
                <li className='li' key={index}>
                  <a href={pdf.url} download className="download-link">
                    {pdf.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageModal;
